import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { needsConsentBanner, setConsent } from '../utils/Analytics';

import './AnalyticsConsent.scss';

/**
 * Asks visitors in Europe before analytics cookies are set. Shows only when analytics is
 * switched on, the visitor has not answered yet, and their time zone is European. Never on
 * the TV screen, which nobody is there to click.
 */
const AnalyticsConsent = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(() => needsConsentBanner());

  if (!open || pathname.startsWith('/player/')) {
    return null;
  }

  const answer = (value: 'granted' | 'denied') => {
    setConsent(value);
    setOpen(false);
  };

  return (
    <div className="analytics-consent" role="dialog" aria-label="Cookies">
      <p>
        Jookable uses Google Analytics cookies to see how the app is used and where from. Nothing that names you is
        sent.
      </p>
      <div className="analytics-consent-buttons">
        <button type="button" className="analytics-consent-no" onClick={() => answer('denied')}>
          No thanks
        </button>
        <button type="button" className="analytics-consent-yes" onClick={() => answer('granted')}>
          Accept
        </button>
      </div>
    </div>
  );
};

export default AnalyticsConsent;
